export default {
  install (Vue, options) {
    /* eslint-disable */
    (function (d, w, c) {
        (w[c] = w[c] || []).push(function() {
            try {
                w[`yaCounter${options.id}`] = new Ya.Metrika({
                    id:options.id,
                    clickmap:true,
                    trackLinks:true,
                    accurateTrackBounce:true,
                    webvisor:true
                });
            } catch(e) { }
        });

        var n = d.getElementsByTagName("script")[0],
            s = d.createElement("script"),
            f = function () { n.parentNode.insertBefore(s, n); };
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://cdn.jsdelivr.net/npm/yandex-metrica-watch/watch.js";

        if (w.opera == "[object Opera]") {
            d.addEventListener("DOMContentLoaded", f, false);
        } else { f(); }
    })(document, window, "yandex_metrika_callbacks");
    /* eslint-enable */

    Vue.prototype.$getYaCounter = () => {
      return window[`yaCounter${options.id}`] || null
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/YaMetrika.js